/* Progressive mobile disclosure. Native details and links work without JS. */
(() => {
  'use strict';
  if (window.ZiloxMobile) { window.ZiloxMobile.refresh(); return; }
  const mq = matchMedia('(max-width: 767px)'), bound = new WeakSet();
  function apply(details) {
    const summary = details.querySelector('summary');
    if (mq.matches && details.contains(document.activeElement) && document.activeElement !== summary) summary?.focus({preventScroll:true});
    details.open = !mq.matches;
    if (summary) { if (mq.matches) summary.removeAttribute('tabindex'); else summary.setAttribute('tabindex','-1'); }
  }
  function refresh(root = document) {
    [...(root.matches?.('[data-zm-disclosure]') ? [root] : []), ...root.querySelectorAll('[data-zm-disclosure]')].forEach(el => {
      if (bound.has(el)) return;
      bound.add(el); apply(el);
      el.addEventListener('toggle', () => { if (!mq.matches && !el.open) el.open = true; });
    });
    root.querySelectorAll('[data-zm-filter]').forEach(select => {
      if (bound.has(select)) return;
      bound.add(select);
      const gallery = select.closest('[data-zs-gallery]');
      const photos = [...gallery.querySelectorAll('[data-zs-photo]')];
      [...select.options].forEach(option => { if (option.value !== 'all' && !photos.some(card => option.value === 'design' ? card.dataset.category !== 'stories' : card.dataset.category === option.value)) option.remove(); });
      if (photos.length > 1) select.closest('[data-zm-filter-wrap]').hidden = false;
      select.addEventListener('change', () => {
        [...gallery.querySelectorAll('[data-zs-filter]')].find(b => b.dataset.zsFilter === select.value)?.click();
      });
      gallery.querySelectorAll('[data-zs-filter]').forEach(button => button.addEventListener('click', () => { select.value = button.dataset.zsFilter; }));
    });
  }
  const resized = () => document.querySelectorAll('[data-zm-disclosure]').forEach(apply);
  if (mq.addEventListener) mq.addEventListener('change', resized); else mq.addListener(resized);
  document.addEventListener('shopify:section:load', e => refresh(e.target));
  window.ZiloxMobile = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), {once:true}); else refresh();
})();
